import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-drawer',
	templateUrl: './drawer.component.html',
	styleUrls: ['./drawer.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DrawerComponent {
	@Input() set isOpen(value: boolean) {
		this._open = value;
	}

	@Output() closeDrawer = new EventEmitter();

	private _open = false;

	get open() {
		return this._open;
	}

	close() {
		this._open = false;
		this.closeDrawer.emit();
	}
}
